/**
* 基础菜单 商品赠品管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>营销管理</el-breadcrumb-item>
        <el-breadcrumb-item>商品赠品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sale_name" placeholder="输入商品销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="输入商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.gift_sale_name" placeholder="输入赠品销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.gift_name" placeholder="输入赠品简称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.gift_product_code" placeholder="输入赠品编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="addGiftdialog" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editGiftdialog" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delGift">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 550px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="sale_name" label="商品销售名称" min-width="160" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div style="white-space: pre;" class="over_text_1">{{scope.row.sale_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="buy_num" label="购买数量" width="80">
        </el-table-column>
        <el-table-column prop="gift_sale_name" label="赠品销售名称" min-width="160" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div style="white-space: pre;"  class="over_text_1">{{scope.row.gift_sale_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="gift_name" label="赠品简称" min-width="100" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div style="white-space: pre;"  class="over_text_1">{{scope.row.gift_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="gift_product_code" label="赠品编码" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="gift_num" label="赠送数量" width="80">
        </el-table-column>
        <el-table-column prop="creater_name" label="创建人" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="135">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="giftDialogVisible"
               width="32%"
               :before-close="handleClose"
               center>
      <el-form label-width="120px" :model="giftForm" :rules="giftRules" ref="giftForm" class="giftForm">
        <el-form-item label="商品销售名称" prop="sale_id" class="relative">
          <el-select v-model="giftForm.sale_id" filterable placeholder="请选择商品销售名称" clearable
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="changeProductName(giftForm.sale_id)" @clear="clear()">
            <el-option :title="item.sale_name"
                       v-for="item in productData"
                       :key="item.sale_id"
                       :label="item.sale_name"
                       :value="item.sale_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="赠品销售名称" prop="gift_sale_id" class="relative">
          <el-select v-model="giftForm.gift_sale_id" filterable placeholder="请选择赠品销售名称" clearable
                     remote :remote-method="remoteMethodGift" class="interval" :popper-append-to-body="false"
                     @focus="focusProductGiftName()" @change="changeProductgiftName(giftForm.gift_sale_id)" @clear="clearGift()">
            <el-option :title="item.sale_name"
                       v-for="item in giftProductData"
                       :key="item.sale_id"
                       :label="item.sale_name"
                       :value="item.sale_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productGiftHandleSizeChange"
                             @current-change="productGiftHandleCurrentChange"
                             :current-page.sync="productGiftCurrentPage"
                             :page-size="productGiftPagesize"
                             layout="total, prev, pager, next"
                             :total="productGiftTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="购买数量" prop="buy_num">
          <el-input size="small" v-model="giftForm.buy_num" auto-complete="off" clearable maxlength="3"
                    placeholder="请输入购买数量"></el-input>
        </el-form-item>
        <el-form-item label="赠品简称" prop="gift_name">
          <el-input size="small" v-model="giftForm.gift_name" auto-complete="off" clearable maxlength="10"
                    placeholder="请输入赠品简称"></el-input>
        </el-form-item>
        <el-form-item label="赠品数量" prop="gift_num">
          <el-input size="small" v-model="giftForm.gift_num" auto-complete="off" clearable maxlength="3"
                    placeholder="请输入赠品数量"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('giftForm')">重 置</el-button>
            <el-button type="primary" @click="saveGift('giftForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  giftList,
  giftAdd,
  giftDetail,
  deleteGift,
  updateGift,
  productList,
  productSaleList, custInfo
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'

  export default {
    name: 'gift',
    data: () => {
      var validateBuyNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入购买数量'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateGiftNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入赠品数量'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        addProductDialogVisible: false,
        giftDialogVisible: false,
        dialogTitle: '',
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          sale_name: '',
          product_code: '',
          gift_sale_name: '',
          gift_name: '',
          gift_product_code: ''
        },
        giftRules: {
          sale_id: [{required: true, message: '请选择商品销售名称', trigger: 'blur'}],
          gift_sale_id: [{required: true, message: '请选择赠品销售名称', trigger: 'blur'}],
          buy_num: [{required: true, validator: validateBuyNum, trigger: 'blur'}],
          gift_name: [{required: true, message: '请输入赠品简称', trigger: 'blur'}],
          gift_num: [{required: true, validator: validateGiftNum, trigger: 'blur'}],
        },
        giftForm: {
          id: '',
          sale_id: "",
          buy_num: '',
          gift_sale_id: "",
          gift_name: "",
          gift_num: ''
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        // rules表单验证
        rules: {},
        dialogImageUrl: '',
        dialogVisible: false,
        imgUrl: '',
        product_id: '',
        product_name: '',
        form: {
          image: ''
        },
        isCanSubmit: true,
        productData: [],
        giftProductData: [],
        //分页
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        productGiftCurrentPage: 1,
        productGiftPagesize: 10,
        productGiftTotalSize: 0,
        saleName: '',
        saleGiftName: '',
        selectedsaleName: '',
        selectedsaleGiftName: '',
        small: true
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          put_away_status: '75',
          // operation_type: '2910'
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getProductGift(saleGiftName) {
        let parameter = {
          page: this.productGiftCurrentPage,
          rows: 10,
          keyword: saleGiftName,
          put_away_status: '75',
          // operation_type: '2910'
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleGiftName = ''
              }
              this.giftProductData = res.rows;
              this.productGiftTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      focusProductGiftName() {
        if (!this.selectedsaleGiftName) {
          this.saleGiftName = ''
          this.getProductGift('')
        }
      },
      changeProductName() {
        this.productCurrentPage = 1
        this.productData.forEach((item) => {
          if (item.sale_id == this.giftForm.sale_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
      },
      changeProductgiftName() {
        this.productGiftCurrentPage = 1
        this.giftProductData.forEach((item) => {
          if (item.sale_id == this.giftForm.gift_sale_id) {
            this.selectedsaleGiftName = item.sale_name;
            this.getProductGift(item.sale_name)
          }
        })
      },
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      clearGift() {
        this.getProductGift()
        this.productGiftCurrentPage = 1
        this.saleGiftName = ''
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      remoteMethodGift(val) {
        this.productGiftCurrentPage = 1
        this.saleGiftName = val;
        this.getProductGift(val)
      },
      // 分页插件事件
      productCallFather() {
        this.getProduct(this.formInline)
      },
      addGiftdialog() {
        this.giftDialogVisible = true;
        this.dialogTitle = '新增商品赠品';
        this.giftForm = {}
        this.getProduct();
        this.getProductGift();
      },
      editGiftdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改商品赠品';
        this.giftDialogVisible = true;
        this.getProduct(this.selectTableData[0].product_code);
        this.getProductGift(this.selectTableData[0].gift_product_code);
        this.loading = true
        giftDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.giftForm.id = res.content.id;
                this.giftForm.sale_id = res.content.sale_id;
                this.giftForm.gift_sale_id = res.content.gift_sale_id;
                this.giftForm.buy_num = res.content.buy_num;
                this.giftForm.gift_name = res.content.gift_name;
                this.giftForm.gift_num = res.content.gift_num;
                this.giftForm = res.content
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      delGift() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否确认删除赠品信息？';
        this.$confirm(title, '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          deleteGift(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      addProduct(id) {
        this.addProductDialogVisible = true;
        this.productId = id;
      },
      saveGift(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增商品赠品') {
              giftAdd(this.giftForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加商品赠品!'
                    });
                    this.giftDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.giftForm.id = this.productId;
              updateGift(this.giftForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改商品赠品!'
                    });
                    this.giftDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        giftList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      sureAddProduct() {
        let addProducts = [];
        this.selectedAddProductTableData.forEach((item) => {
          addProducts.push(item.sale_id)
        })
        let parameter = {
          id: this.productId,
          addProducts: addProducts
        }
        saveProductGift(parameter)
          .then(res => {
            this.isCanSubmit = true;
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功为店铺分类添加商品!'
              });
              this.addProductDialogVisible = false;
            }
          })
          .catch(err => {
            this.isCanSubmit = true;
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      productGiftHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productGiftPagesize = val;
        this.getProductGift(this.saleGiftName)
      },
      productGiftHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productGiftCurrentPage = val;
        this.getProductGift(this.saleGiftName)
      },
      handleClose() {
        this.$refs["giftForm"].resetFields();
        this.giftDialogVisible = false;
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.sale_name == cell.innerText || row.product_code == cell.innerText || row.sale_name == cell.innerText || row.gift_sale_name == cell.innerText || row.gift_product_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .giftForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 380px;
  }

  /deep/ .giftForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .giftForm .el-select-dropdown__item {
    width: 380px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .giftForm .el-input--small {
    width: 380px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

</style>





// WEBPACK FOOTER //
// src/views/Marketing/Gift.vue